module.exports = __webpack_public_path__ + "img/J.031c0cf8.jpg";